var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29325_107249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29325_107249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 14.1667H10.8346V9.16675H9.16797V14.1667ZM10.0013 7.50008C10.2374 7.50008 10.4353 7.42022 10.5951 7.2605C10.7548 7.10078 10.8346 6.90286 10.8346 6.66675C10.8346 6.43064 10.7548 6.23272 10.5951 6.073C10.4353 5.91328 10.2374 5.83341 10.0013 5.83341C9.76519 5.83341 9.56727 5.91328 9.40755 6.073C9.24783 6.23272 9.16797 6.43064 9.16797 6.66675C9.16797 6.90286 9.24783 7.10078 9.40755 7.2605C9.56727 7.42022 9.76519 7.50008 10.0013 7.50008ZM10.0013 18.3334C8.84852 18.3334 7.76519 18.1147 6.7513 17.6772C5.73741 17.2397 4.85547 16.6459 4.10547 15.8959C3.35547 15.1459 2.76172 14.264 2.32422 13.2501C1.88672 12.2362 1.66797 11.1529 1.66797 10.0001C1.66797 8.8473 1.88672 7.76397 2.32422 6.75008C2.76172 5.73619 3.35547 4.85425 4.10547 4.10425C4.85547 3.35425 5.73741 2.7605 6.7513 2.323C7.76519 1.8855 8.84852 1.66675 10.0013 1.66675C11.1541 1.66675 12.2374 1.8855 13.2513 2.323C14.2652 2.7605 15.1471 3.35425 15.8971 4.10425C16.6471 4.85425 17.2409 5.73619 17.6784 6.75008C18.1159 7.76397 18.3346 8.8473 18.3346 10.0001C18.3346 11.1529 18.1159 12.2362 17.6784 13.2501C17.2409 14.264 16.6471 15.1459 15.8971 15.8959C15.1471 16.6459 14.2652 17.2397 13.2513 17.6772C12.2374 18.1147 11.1541 18.3334 10.0013 18.3334ZM10.0013 16.6667C11.8624 16.6667 13.4388 16.0209 14.7305 14.7292C16.0221 13.4376 16.668 11.8612 16.668 10.0001C16.668 8.13897 16.0221 6.56258 14.7305 5.27091C13.4388 3.97925 11.8624 3.33341 10.0013 3.33341C8.14019 3.33341 6.5638 3.97925 5.27214 5.27091C3.98047 6.56258 3.33464 8.13897 3.33464 10.0001C3.33464 11.8612 3.98047 13.4376 5.27214 14.7292C6.5638 16.0209 8.14019 16.6667 10.0013 16.6667Z",
    fill: "#0040BF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;